/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Formik and Yup
import { Field, FieldArray, Form, Formik, useFormik } from "formik";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components

import DataTable from "examples/Tables/DataTable";

// @mui material components
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import TextError from "utils/TextError";
// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

//  some date function

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CancelIcon from "@mui/icons-material/Clear";
// Functions from store
import {
  createQuarantineForAcceptedListW2,
  getAcceptedQuarantines,
  getCreatedActivity,
  getDocumentType,
  getItemCodeByWarehouse,
  getLocationsForQuarantine,
  getSkuByDocumentNo,
  getSkuByItemCode,
  getSkuStatusByLocationAndItemCode,
  getSubModulesByRoleId,
  getWarehouses,
  releaseQuarantine,
} from "../../../../store";

// config file
import Config from "../../../../config/index";

// Cookies
import Cookies from "universal-cookie";
// import { getAcceptedQuarantines } from "store/quarantine/quarantineActions";
import ViewButton from "components/standardized-components/ViewButton";
import { addMinutes, format } from "date-fns";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForCreate = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 380, md: 800, lg: 1200, xl: 850 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  overflow: "scroll",
};

const styleForStationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 1100 },
  boxShadow: 24,
  p: 0,
  pt: 3,
};
const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};
const styleForPickup = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};
const AcceptedQuarantinesW2 = ({
  getAcceptedQuarantines,
  createQuarantineForAcceptedListW2,
  acceptedQuarantinesReducer,
  getSkuStatusByLocationAndItemCode,
  getSkuStatusByLocationAndItemCodeReducer,

  getSkuByDocumentNoReducer,
  itemCodeByWarehouseReducer,
  getDocumentType,
  locationReducer,

  getLocationsForQuarantine,
  getSkuByItemCode,
  getSkuByItemCodeReducer,
  getWarehouses,
  releaseQuarantine,
  warehouses,
  getItemCodeByWarehouse,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getSkuByDocumentNo,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails.data.userId;
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let acceptedquarantineModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "47c61432-3c8e-4b04-a9b4-7bc989bab18a",
  );

  // let viewQuarantine = acceptedquarantineModule
  //   ? acceptedquarantineModule.actionId.includes(
  //       "1ec6c05a-81ea-4d16-91d5-82007bee18cb"
  //     )
  //   : null;
  let createQuarantine = acceptedquarantineModule
    ? acceptedquarantineModule.actionId.includes(
        "1ec6c05a-81ea-4d16-91d5-82007bee18cb",
      )
    : null;
  let releaseQuarantineAccess = acceptedquarantineModule
    ? acceptedquarantineModule.actionId.includes("")
    : null;

  let createPicklistAccess = acceptedquarantineModule
    ? acceptedquarantineModule.actionId.includes("")
    : null;

  let viewSuidsAccess = acceptedquarantineModule
    ? acceptedquarantineModule.actionId.includes(
        "b870bcc5-f726-4e88-93eb-06f408fccd83",
      )
    : null;

  const navigate = useNavigate();

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [errorMsg, setErrorMsg] = useState("");
  const [errorMsgForCreatePickup, setErrorMsgForCreatePickup] = useState("");
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [documentNo, setDocumentNo] = useState("");

  useEffect(() => {
    viewSuidsAccess &&
      getAcceptedQuarantines(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewSuidsAccess, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "Document No", accessor: "documentNumber" },
      // { Header: "Total Qty", accessor: "totalQty" },
      { Header: "Item Code", accessor: "itemCode" },
      { Header: "Item Description", accessor: "itemDescription" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },

      {
        Header: "action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  const [stationModal, setOpenStationModal] = useState(false);
  const [documentNumber, setdocumentNumber] = useState("");

  const handleOpenStationModal = () => {
    setOpenStationModal(true);
  };
  const handleCloseStationModal = () => {
    setOpenStationModal(false);
  };
  const [documentNumberForPicklist, setDocumentNumberForPicklist] =
    useState("");

  useEffect(() => {
    let tempQuarantineSku = [];
    let data = acceptedQuarantinesReducer.acceptedQuarantines.data
      ? acceptedQuarantinesReducer.acceptedQuarantines.data
      : [];
    setPaginationObj(
      acceptedQuarantinesReducer.acceptedQuarantines?.pagination,
    );
    setLoading(acceptedQuarantinesReducer.loading);
    data.map((quarantine) => {
      const formatDate = new Date(quarantine.cd);
      let des = quarantine?.itemDescription;
      let len = desLength;
      const obj = {
        documentNumber: quarantine.documentNumber,
        totalQty: `${quarantine.totalQty}`,
        itemCode: quarantine.itemCode ? `${quarantine.itemCode}` : "",
        itemDescription: `${des ? des.substring(0, len) : ""}`,
        sku: `${quarantine.sku ? quarantine.sku : "NA"}`,
        location: quarantine.locationCode,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "do MMMM yyyy h:mm a",
        ),
        cd: quarantine.cd,
        qty: `${quarantine.qty} ${quarantine.uom}`,
        lotSerialNo: `${quarantine.lotNumber ? quarantine.lotNumber : "NA"} / ${
          quarantine.serialNumber ? quarantine.serialNumber : "NA"
        }`,
        uom: `${quarantine.uom}`,
        action: (
          <>
            {/* {releaseAccess && ( */}
            {/* <StandardButton
              disabled={quarantine.isDisabled === 0}
              tooltip="Create Picklist"
              style={{
                marginLeft: "0.5rem",
              }}
              type="button"
              variant="gradient"
              color="warning"
              icon="rotate_right"
              iconOnly
              onClick={() => {
                handleOpenCreatePickupModal(quarantine);
                getCreatedActivity("", jwtToken);
                setDocumentNumberForPicklist(quarantine.documentNumber);
              }}
            >
              {" "}
              <Icon>forward</Icon>
            </StandardButton> */}

            {/* )} */}
            {viewSuidsAccess && (
              <ViewButton
                tooltip="View SUID"
                style={{
                  marginLeft: "0.5rem",
                }}
                variant="gradient"
                color="info"
                iconOnly
                type="button"
                onClick={() => {
                  setDocumentNo(quarantine?.documentNumber);
                  handleOpenStationModal(quarantine);
                  getSkuByDocumentNo(quarantine?.documentTrId, jwtToken);
                }}
              >
                <Icon> visibility_icon </Icon>
              </ViewButton>
            )}
          </>
        ),
      };
      tempQuarantineSku.push(obj);
    });
    setState({ ...state, rows: tempQuarantineSku });
  }, [acceptedQuarantinesReducer]);

  const ageingOptions = [
    { label: "RTV", value: "QARRTV" },
    { label: "SCRAP", value: "QARSCRAP" },
  ];

  const [acnOptions, setAcnOptions] = useState([]);
  // useEffect(() => {
  //   let tempCreatedActivityOptions = [];
  //   let data = getCreatedActivityReducer.activity.data || [];
  //   let filteredActivities = data.filter(
  //     (activity) =>
  //       activity.mvtCode === "RMW-QARSCRAP" || activity.mvtCode === "RMW-QARRTV"
  //   );

  //   filteredActivities.map((activity) => {
  //     tempCreatedActivityOptions.push({
  //       label: activity.mvtCode,
  //       value: activity.mvtId,
  //     });
  //   });

  //   setAcnOptions(tempCreatedActivityOptions);
  // }, [getCreatedActivityReducer]);

  const [CreatePickupModal, setCreatePickupModal] = useState(false);

  const handleOpenCreatePickupModal = () => {
    setCreatePickupModal(true);
    // formikForRelease.setValues(initialValuesForRelease);
    // formikForRelease.setTouched({});
    // formikForRelease.setErrors({});
  };
  const handleCloseCreatePickupModal = () => {
    setCreatePickupModal(false);
    setSelectedAcn("");
  };
  const [isErrorForReleaseCreatePickup, setIsErrorForReleaseCreatePickup] =
    useState(false);
  const [isSuccessForReleaseCreatePickup, setIsSuccessForCreatePickup] =
    useState(false);

  const [allocateUserModal, setAllocateUserModal] = useState(false);

  const handleOpenAllocateUserModal = () => {
    setAllocateUserModal(true);
    formikForRelease.setValues(initialValuesForUser);
    formikForRelease.setTouched({});
    formikForRelease.setErrors({});
  };
  const handleCloseAllocateUserModal = () => {
    setAllocateUserModal(false);
  };
  const [isErrorForAllocate, setIsErrorForAllocate] = useState(false);
  const [isSuccessForAllocate, setIsSuccessForAllocate] = useState(false);

  const initialValuesForUser = {
    user: "",
  };

  const [releaseName, setReleaseName] = useState("Release");

  const submitForUser = async (values) => {
    setReleaseName("Please wait...");
    let payload = {
      // mvtId: 3,
      suid: documentNumber,

      userId: userId,
    };

    let res = await releaseQuarantine(payload, jwtToken);
    if (res.status) {
      setIsSuccessForAllocate(true);
      getAcceptedQuarantines(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setIsSuccessForAllocate(false);
      }, 2000);
      setTimeout(() => {
        handleCloseAllocateUserModal(false);
        setReleaseName("Release");
      }, 3000);
    }
    if (!res.status) {
      setErrorMsg(res.data);
      setIsErrorForAllocate(true);
      setTimeout(() => {
        setIsErrorForAllocate(false);
      }, 3000);
      setReleaseName("Release");
    }
  };

  const formikForRelease = useFormik({
    initialValues: initialValuesForUser,
    onSubmit: submitForUser,
  });

  const skuStatusOptionsForQuar = [{ label: "Open", value: "0" }];

  const [locationOptions, setLocationOptions] = useState([]);

  useEffect(() => {
    let tempSuidOptions = [];
    let data = locationReducer.locations.data
      ? locationReducer.locations.data
      : [];
    data.map((suid) => {
      tempSuidOptions.push({
        label: suid.locationName,
        value: suid.locationCode,
        // sLocation: suid.locationCode,
      });
    });
    setLocationOptions(tempSuidOptions);
  }, [locationReducer]);

  const [activityIdSelected, setActivityIdSelected] = useState("");

  const [selectedItemCode, setSelectedItemCode] = useState("");
  const [selectedSkuStatus, setSelectedSkuStatus] = useState(null);
  const [selectedLocationId, setSelectedLocationId] = useState(null);

  useEffect(() => {
    getItemCodeByWarehouse(
      activityIdSelected?.value,
      selectedSkuStatus?.value,
      jwtToken,
    );
  }, [activityIdSelected, selectedSkuStatus]);
  useEffect(() => {
    getLocationsForQuarantine(
      selectedItemCode?.value,
      selectedSkuStatus?.value,
      jwtToken,
    );
  }, [selectedItemCode, selectedSkuStatus]);

  useEffect(() => {
    getSkuStatusByLocationAndItemCode(
      selectedLocationId?.value,
      selectedItemCode?.value,
      selectedSkuStatus?.value,
      jwtToken,
    );
  }, [selectedLocationId, selectedItemCode, selectedSkuStatus]);
  useEffect(() => {
    getSkuByItemCode(
      selectedItemCode?.value,
      selectedSkuStatus?.value,
      jwtToken,
    );
  }, [selectedItemCode, selectedSkuStatus]);
  useEffect(() => {
    getSkuStatusByLocationAndItemCode(
      activityIdSelected?.id,
      selectedItemCode?.value,
      selectedSkuStatus?.value,
      jwtToken,
    );
  }, [activityIdSelected, selectedItemCode, selectedSkuStatus]);

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
  };

  const [itemCodeForWarehouseOptions, setItemCodeForWarehouseOptions] =
    useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemCodeByWarehouseReducer.itemCodes
      ? itemCodeByWarehouseReducer.itemCodes
      : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeForWarehouseOptions(tempItemCodeOptions);
  }, [itemCodeByWarehouseReducer]);

  const [skuStatusOptions, setSkuStatusOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getSkuStatusByLocationAndItemCodeReducer.skuStatus.data
      ? getSkuStatusByLocationAndItemCodeReducer.skuStatus.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.suid,
        value: activity.suid,
        qty: activity.qty,
      });
    });
    setSkuStatusOptions(tempCreatedActivityOptions);
  }, [getSkuStatusByLocationAndItemCodeReducer]);
  const [skuOptions, setSkuOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getSkuByItemCodeReducer.sku.data
      ? getSkuByItemCodeReducer.sku.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.suid,
        value: activity.suid,
        qty: activity.qty,
        location: activity.locationName,
      });
    });
    setSkuOptions(tempCreatedActivityOptions);
  }, [getSkuByItemCodeReducer]);
  const [stationTable, setStationTable] = useState({
    columns: [
      { Header: "SUID", accessor: "sku" },

      { Header: "Item Code", accessor: "itemCode" },
      { Header: "Item Description", accessor: "itemDescription" },
      { Header: "Quarantine Location", accessor: "rejectedLocation" },
      { Header: "Location", accessor: "location" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      { Header: "LOT/Serial No", accessor: "lotSerialNo" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      { Header: "Remarks", accessor: "remarks" },
      // { Header: "Action", accessor: "action" },
    ],
    rows: [],
  });

  const [loading2, setLoading2] = useState(true);

  const { columns: stationColumns, rows: stationRows } = stationTable;

  useEffect(() => {
    let tempStations = [];
    let data = getSkuByDocumentNoReducer.sku
      ? getSkuByDocumentNoReducer.sku
      : [];
    setLoading2(getSkuByDocumentNoReducer.loading);
    data.map((station) => {
      const formatDate = new Date(station.cd);
      let des = station?.itemDescription;
      let len = desLength;
      const stationObj = {
        sku: station.suid,
        remarks: station.remark,
        itemCode: station.itemCode ? `${station.itemCode}` : "",
        itemDescription: `${des ? des.substring(0, len) : ""}`,
        rejectedLocation: station.rejectedLocation,
        location: station.locationCode,
        qty: `${station.qty}`,
        uom: `${station.uom}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "do MMMM yyyy h:mm a",
        ),
        cd: station.cd,
        lotSerialNo: `${station.lotNumber ? station.lotNumber : "NA"} / ${
          station.serialNumber ? station.serialNumber : "NA"
        }`,
        // action: (
        //   <ReleaseButton
        //     tooltip="Release"
        //     style={{
        //       marginLeft: "0.5rem",
        //     }}
        //     disabled={station.isDisabled === 1}
        //     type="button"
        //     variant="gradient"
        //     color="success"
        //     iconOnly
        //     onClick={() => {
        //       setdocumentNumber(station.suid);
        //       handleOpenAllocateUserModal(station);
        //       // getCreatedActivity("", jwtToken);
        //     }}
        //   >
        //     {" "}
        //     <Icon>forward</Icon>
        //   </ReleaseButton>
        // ),
      };
      tempStations.push(stationObj);
    });

    // viewStations &&
    setStationTable({ ...stationTable, rows: tempStations });
  }, [getSkuByDocumentNoReducer]);

  const initialValues = {
    rejectionFrom: "",
    documentNumber: "",
    rejectionType: "itemCode",
    itemsForLocation: [
      {
        itemId: "",
        skuStatus: "",
        location: "",
        sku: "",
      },
    ],
    itemsForItemCode: [
      {
        itemId: "",
        sku: "",
        skuStatus: "",
      },
    ],
  };

  const [selectedAcn, setSelectedAcn] = useState("");

  const handleAcnChange = (selectedUser) => {
    setSelectedAcn(selectedUser);
  };

  const [picklistName, setPicklistName] = useState("Create Picklist");

  const submitForCreatePickup = async (values) => {
    setPicklistName("Please wait...");
    let payload = {
      movement: selectedAcn?.value,

      userId: userId,
      documentNumber: documentNumberForPicklist,
    };
    // let res = await createPickupListForQuarantineW2(payload, jwtToken);
    // if (res.status) {
    //   setIsSuccessForCreatePickup(true);
    //   getAcceptedQuarantines(pageNo, rowsPerPage, searchObject, jwtToken);
    //   setTimeout(() => {
    //     setIsSuccessForCreatePickup(false);
    //   }, 2000);
    //   setTimeout(() => {
    //     handleCloseCreatePickupModal(false);
    //     setPicklistName("Create Picklist");
    //   }, 3000);
    // }
    // if (!res.status) {
    //   setErrorMsgForCreatePickup(res.data.data.msg);
    //   setIsErrorForReleaseCreatePickup(true);
    //   setTimeout(() => {
    //     setIsErrorForReleaseCreatePickup(false);
    //   }, 3000);
    //   setPicklistName("Create Picklist");
    // }
  };

  const initialValuesForPickUp = {
    movement: "",
  };
  const formikForCreatePickUp = useFormik({
    initialValues: initialValuesForPickUp,
    onSubmit: submitForCreatePickup,
  });

  const [buttonName, setButtonName] = useState("Submit");

  const onSubmitForCreateQuarantine = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    if (values.rejectionType === "location") {
      let payload = {
        remarks: values.documentNumber,
        userId: userId,
        suids: values.itemsForLocation.map((item) => ({
          suid: item.sku,
          itemId: item.itemId,
          qty: item.qty,
        })),
      };
      let res = await createQuarantineForAcceptedListW2(payload, jwtToken);

      if (res.status) {
        setIsSuccessCreatedQuarantine(true);

        getAcceptedQuarantines(pageNo, rowsPerPage, searchObject, jwtToken);
        resetForm();

        setActivityIdSelected("");
        setTimeout(() => {
          handleCloseCreateQuarantineModal();
          setButtonName("Submit");
        }, 2500);
      }

      if (!res.status) {
        setIsErrorCreatedQuarantine(true);
        setErrorMsgForCreate(res.data.data.msg);
        setButtonName("Submit");
      }
    }
    if (values.rejectionType === "itemCode") {
      let payload = {
        remarks: values.documentNumber,

        userId: userId,
        suids: values.itemsForItemCode.map((item) => ({
          suid: item.sku,
          itemId: item.itemId,
          qty: item.qty,
        })),
      };

      let res = await createQuarantineForAcceptedListW2(payload, jwtToken);

      if (res.status) {
        setIsSuccessCreatedQuarantine(true);
        getAcceptedQuarantines(pageNo, rowsPerPage, searchObject, jwtToken);
        resetForm();
        setActivityIdSelected("");
        setTimeout(() => {
          handleCloseCreateQuarantineModal();
          setButtonName("Submit");
        }, 2500);
      }

      if (!res.status) {
        setIsErrorCreatedQuarantine(true);
        setErrorMsgForCreate(res.data.data.msg);
        setButtonName("Submit");
      }
    }
  };

  const [isSuccessCreatedQuarantine, setIsSuccessCreatedQuarantine] =
    useState(false);
  const [isErrorCreatedQuarantine, setIsErrorCreatedQuarantine] =
    useState(false);

  useEffect(() => {
    if (isErrorCreatedQuarantine) {
      setTimeout(() => {
        setIsErrorCreatedQuarantine(false);
      }, 3000);
    }
  }, [isErrorCreatedQuarantine]);

  useEffect(() => {
    if (isSuccessCreatedQuarantine) {
      setTimeout(() => {
        setIsSuccessCreatedQuarantine(false);
      }, 3000);
    }
  }, [isSuccessCreatedQuarantine]);

  const [createQuarantineModal, setCreateQuarantineModal] = useState(false);

  const handleCreateQuarantineModal = () => {
    setCreateQuarantineModal(true);
  };
  const handleCloseCreateQuarantineModal = () => {
    setActivityIdSelected("");
    setCreateQuarantineModal(false);
  };

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];

    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseCode,
        id: warehouse.warehouseId,
        // key: warehouse.warehouseCode,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {createQuarantine && (
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-6}
              >
                <MDBox color="text" px={2} ml={-2} mb={1}>
                  <CreateButton
                    tooltip="Create Quarantine"
                    style={{ marginRight: "1rem" }}
                    color="info"
                    iconOnly
                    type="button"
                    onClick={(event) => {
                      handleCreateQuarantineModal();
                      getDocumentType(jwtToken);

                      getWarehouses(jwtToken);
                    }}
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                </MDBox>
              </MDBox>
            )}

            <MDBox pt={3}>
              {!loading ? (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  hideColumns={["", "asnCode", "vendorCodeName"]}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "100px",
                    marginBottom: "100px",
                  }}
                >
                  <CircularProgress color="info" />
                </div>
              )}
            </MDBox>
            <Modal
              open={CreatePickupModal}
              onClose={handleCloseCreatePickupModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForPickup}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Picklist
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreatePickupModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForCreatePickUp.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                        Document Number:-{" "}
                        <span style={{ fontWeight: 400 }}>
                          {documentNumberForPicklist}
                        </span>
                      </MDTypography>
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorForReleaseCreatePickup}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForReleaseCreatePickup(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForCreatePickup}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForReleaseCreatePickup}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessForCreatePickup(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Picklist released Successfully
                        </Alert>
                      </Collapse>
                    </MDBox>

                    <MDBox mt={3}>
                      <MDButton
                        color="warning"
                        fullWidth
                        type="submit"
                        disabled={
                          // !formikForCreatePickUp.isValid ||
                          picklistName === "Please wait..."
                        }
                      >
                        {picklistName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={stationModal}
              onClose={handleCloseStationModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForStationModal}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Document No:{documentNo}
                  </MDTypography>

                  <MDBox display="flex" marginLeft="auto">
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            display: "flex",
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "auto",
                            marginBottom: "5px",
                            marginRight: "10px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseStationModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginBottom: "1rem" }} />
                <MDBox>
                  {!loading2 ? (
                    <DataTable
                      table={{ columns: stationColumns, rows: stationRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                        marginBottom: "100px",
                      }}
                    >
                      <CircularProgress color="info" />
                    </div>
                  )}
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={createQuarantineModal}
              onClose={handleCloseCreateQuarantineModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreate}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Quarantine
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseCreateQuarantineModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox>
                    <MDBox>
                      <Grid container>
                        <Formik
                          initialValues={initialValues}
                          // validationSchema={validationSchema}
                          onSubmit={onSubmitForCreateQuarantine}
                        >
                          {(formik) => {
                            return (
                              <Form>
                                <div>
                                  <MDBox
                                  // style={{
                                  //   // position: "sticky",
                                  //   top: "0",
                                  //   width: "100%",
                                  //   // zIndex: 999,
                                  // }}
                                  >
                                    <Grid container>
                                      <Grid item xs={12} lg={6}>
                                        <MDBox
                                          mb={1}
                                          ml={1}
                                          // style={{ width: "370px" }}
                                        >
                                          <MDTypography
                                            variant="h6"
                                            style={{ fontWeight: "500" }}
                                          >
                                            Quarantine From
                                          </MDTypography>
                                          <Select
                                            isClearable
                                            className="select-css"
                                            maxMenuHeight={90}
                                            // placeholder="Choose one..."
                                            name="rejectionFrom"
                                            onBlur={() => {
                                              formik.handleBlur({
                                                target: {
                                                  name: "rejectionFrom",
                                                },
                                              });
                                            }}
                                            value={activityIdSelected}
                                            options={warehouseOptions}
                                            onChange={(selectedOption) => {
                                              handleActivityIdChange(
                                                selectedOption,
                                              );
                                              formik.setFieldValue(
                                                "rejectionFrom",
                                                selectedOption,
                                              );
                                            }}
                                          />
                                          {formik.touched.rejectionFrom &&
                                            formik.errors.rejectionFrom && (
                                              <TextError
                                                msg={
                                                  formik.errors.rejectionFrom
                                                }
                                              />
                                            )}
                                        </MDBox>
                                      </Grid>
                                      <Grid item xs={12} lg={6}>
                                        <MDBox
                                          mb={1}
                                          ml={1}
                                          style={{ width: "370px" }}
                                        >
                                          <MDTypography
                                            variant="h6"
                                            style={{ fontWeight: "500" }}
                                          >
                                            Remarks
                                          </MDTypography>
                                          <Field
                                            className="form-control"
                                            type="text"
                                            name="documentNumber"
                                            fullWidth
                                            autoComplete="off"
                                            onChange={formik.handleChange}
                                            value={formik.values.documentNumber}
                                            error={
                                              formik.touched.documentNumber &&
                                              formik.errors.documentNumber &&
                                              true
                                            }
                                            inputProps={{
                                              style: {
                                                height: "14px",
                                              },
                                              maxLength: 45,
                                            }}
                                          />
                                          {formik.errors.documentNumber && (
                                            <TextError
                                              msg={formik.errors.documentNumber}
                                            />
                                          )}
                                        </MDBox>
                                      </Grid>
                                    </Grid>
                                  </MDBox>

                                  {/* <hr style={{ marginBottom: "10px" }} /> */}

                                  <MDBox>
                                    <div
                                      style={{
                                        display: "flex",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div>
                                        <Field
                                          type="radio"
                                          name="rejectionType"
                                          value="itemCode"
                                          className="radio"
                                        />
                                        <span>
                                          <MDTypography
                                            variant="h6"
                                            fontWeight="medium"
                                            style={{
                                              marginLeft: "1.5rem",
                                              marginRight: "10px",
                                              fontSize: "15px",
                                              marginTop: "-1.77rem",
                                              fontWeight: 500,
                                            }}
                                          >
                                            Item Code
                                          </MDTypography>
                                        </span>
                                      </div>
                                      <div>
                                        <Field
                                          type="radio"
                                          name="rejectionType"
                                          value="location"
                                          className="radio"
                                        />
                                        <span>
                                          <MDTypography
                                            variant="h6"
                                            fontWeight="medium"
                                            style={{
                                              marginLeft: "1.5rem",
                                              fontSize: "15px",
                                              marginTop: "-1.77rem",
                                              fontWeight: 500,
                                            }}
                                          >
                                            Location
                                          </MDTypography>
                                        </span>
                                      </div>
                                    </div>
                                  </MDBox>

                                  {formik.values.rejectionType ===
                                    "itemCode" && (
                                    <MDBox>
                                      <MDTypography variant="h5">
                                        Items
                                      </MDTypography>
                                      <hr style={{ marginBottom: "10px" }} />

                                      <FieldArray name="itemsForItemCode">
                                        {(fieldArrayProps) => {
                                          const { push, remove, form } =
                                            fieldArrayProps;
                                          const { values } = form;
                                          const { itemsForItemCode } = values;

                                          return (
                                            <div>
                                              {itemsForItemCode.map(
                                                (item, index) => {
                                                  return (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                      key={index}
                                                    >
                                                      <Grid
                                                        container
                                                        spacing={2}
                                                      >
                                                        {/* SKU Status */}
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={6}
                                                          lg={6}
                                                        >
                                                          <MDBox>
                                                            <MDTypography variant="h6">
                                                              SUID Status
                                                            </MDTypography>
                                                            <Select
                                                              // className="select-css-forSku"
                                                              maxMenuHeight={90}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  // width:
                                                                  //   "170px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                activityIdSelected
                                                                  ? false
                                                                  : true
                                                              }
                                                              options={
                                                                skuStatusOptionsForQuar
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                setSelectedSkuStatus(
                                                                  selectedOption,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForItemCode.${index}.skuStatus`,
                                                                  selectedOption?.value,
                                                                );
                                                              }}
                                                              value={skuStatusOptionsForQuar.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  selectedSkuStatus,
                                                              )}
                                                              // value={itemsForItemCode.skuStatus}
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        {/* Item Code */}
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={6}
                                                          lg={6}
                                                        >
                                                          <MDBox
                                                            ml={{
                                                              xs: 0,
                                                              sm: -0.7,
                                                            }}
                                                          >
                                                            <MDTypography variant="h6">
                                                              Item Code
                                                            </MDTypography>
                                                            <Select
                                                              // className="select-css-for-itemcode"
                                                              maxMenuHeight={75}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  // width: "100%",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                !formik.values
                                                                  .itemsForItemCode[
                                                                  index
                                                                ].skuStatus
                                                              }
                                                              options={
                                                                itemCodeForWarehouseOptions
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                setSelectedItemCode(
                                                                  selectedOption,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForItemCode.${index}.itemId`,
                                                                  selectedOption?.value,
                                                                );
                                                              }}
                                                              value={
                                                                itemsForItemCode.itemId
                                                              }
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        {/* Location */}
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={6}
                                                          lg={6}
                                                        >
                                                          <MDBox
                                                          // ml={{ xs: 0 }}
                                                          // mb={1}
                                                          >
                                                            <MDTypography variant="h6">
                                                              SUID/QTY
                                                            </MDTypography>
                                                            <Select
                                                              // className="select-css-for-sku-item"
                                                              maxMenuHeight={70}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  // width:
                                                                  //   "390px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                !formik.values
                                                                  .itemsForItemCode[
                                                                  index
                                                                ].itemId
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                formik.setFieldValue(
                                                                  `itemsForItemCode.${index}.sku`,
                                                                  selectedOption?.value,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForItemCode.${index}.sLocation`,
                                                                  selectedOption?.sLocation,
                                                                );
                                                                const selectedItem =
                                                                  skuOptions.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      selectedOption?.value,
                                                                  );
                                                                const location =
                                                                  selectedItem
                                                                    ? selectedItem.location
                                                                    : "";
                                                                const qty =
                                                                  selectedItem
                                                                    ? selectedItem.qty
                                                                    : 0; // Get qty

                                                                formik.setFieldValue(
                                                                  `itemsForItemCode.${index}.location`,
                                                                  location,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForItemCode.${index}.qty`,
                                                                  qty,
                                                                ); // Set qty
                                                              }}
                                                              options={
                                                                skuOptions
                                                              }
                                                              getOptionLabel={(
                                                                option,
                                                              ) =>
                                                                `${option.value} / ${option.qty}`
                                                              } // Show both SKU and Qty
                                                              value={skuOptions.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  itemsForItemCode.sku,
                                                              )}
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        {/* SKU */}
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={4}
                                                          lg={3}
                                                        >
                                                          <MDBox
                                                            ml={{
                                                              xs: 0,
                                                              sm: -0.5,
                                                            }}
                                                            mb={2}
                                                          >
                                                            <MDTypography variant="h6">
                                                              Location
                                                            </MDTypography>
                                                            <Field
                                                              disabled
                                                              className="form-control"
                                                              style={{
                                                                borderRadius: 5,
                                                                height: "36px",
                                                                paddingLeft:
                                                                  "15px",
                                                                // width: "305px",
                                                              }}
                                                              type="text"
                                                              name={`itemsForItemCode.${index}.location`}
                                                              value={
                                                                itemsForItemCode[
                                                                  index
                                                                ]?.location
                                                              }
                                                              fullWidth
                                                              autoComplete="off"
                                                              onChange={
                                                                formik.handleChange
                                                              }
                                                              inputProps={{
                                                                style: {
                                                                  height:
                                                                    "36px",
                                                                },
                                                                maxLength: 45,
                                                                readOnly: true,
                                                              }}
                                                            />
                                                            {formik.touched
                                                              .location &&
                                                              formik.errors
                                                                .location && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .location
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>

                                                        {/* Action buttons */}
                                                        <Grid
                                                          item
                                                          xs={3}
                                                          sm={6}
                                                          md={4}
                                                          lg={1}
                                                        >
                                                          <MDBox
                                                            display="flex"
                                                            alignItems="center"
                                                            mt={3}
                                                            ml={18}
                                                          >
                                                            {index > 0 && (
                                                              <CancelIcon
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                type="button"
                                                                className="secondary"
                                                                onClick={() =>
                                                                  remove(index)
                                                                }
                                                                color="error"
                                                              />
                                                            )}
                                                            {index ===
                                                              itemsForItemCode.length -
                                                                1 && (
                                                              <Tooltip title="Add Items">
                                                                <AddCircleIcon
                                                                  fontSize="large"
                                                                  onClick={() =>
                                                                    push({
                                                                      itemId:
                                                                        "",
                                                                      sku: "",
                                                                      skuStatus:
                                                                        "",
                                                                    })
                                                                  }
                                                                  color="info"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              </Tooltip>
                                                            )}
                                                          </MDBox>
                                                        </Grid>
                                                      </Grid>
                                                    </div>
                                                  );
                                                },
                                              )}
                                            </div>
                                          );
                                        }}
                                      </FieldArray>
                                    </MDBox>
                                  )}

                                  {formik.values.rejectionType ===
                                    "location" && (
                                    <MDBox>
                                      <MDTypography variant="h5">
                                        Items
                                      </MDTypography>
                                      <hr style={{ marginBottom: "10px" }} />

                                      <FieldArray name="itemsForLocation">
                                        {(fieldArrayProps) => {
                                          const { push, remove, form } =
                                            fieldArrayProps;
                                          const { values } = form;
                                          const { itemsForLocation } = values;

                                          return (
                                            <div>
                                              {itemsForLocation.map(
                                                (item, index) => {
                                                  return (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                      key={index}
                                                    >
                                                      <Grid
                                                        container
                                                        spacing={2}
                                                      >
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={6}
                                                          lg={6}
                                                        >
                                                          <MDBox>
                                                            <MDTypography variant="h6">
                                                              SUID Status
                                                            </MDTypography>
                                                            <Select
                                                              // className="select-css-forSku"
                                                              maxMenuHeight={90}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  width:
                                                                    "305px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                activityIdSelected
                                                                  ? false
                                                                  : true
                                                              }
                                                              options={
                                                                skuStatusOptionsForQuar
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                setSelectedSkuStatus(
                                                                  selectedOption,
                                                                );

                                                                formik.setFieldValue(
                                                                  `itemsForLocation.${index}.skuStatus`,
                                                                  selectedOption?.value,
                                                                );
                                                              }}
                                                              value={skuStatusOptionsForQuar.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  selectedSkuStatus,
                                                              )}
                                                            />
                                                            {formik.touched
                                                              .skuStatus &&
                                                              formik.errors
                                                                .skuStatus && (
                                                                <TextError
                                                                  msg={
                                                                    formik
                                                                      .errors
                                                                      .skuStatus
                                                                  }
                                                                />
                                                              )}
                                                          </MDBox>
                                                        </Grid>
                                                        {/* Item Code Field */}
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={6}
                                                          lg={5}
                                                        >
                                                          <MDBox
                                                            ml={{
                                                              xs: -2,
                                                              sm: -3,
                                                            }}
                                                          >
                                                            <MDTypography variant="h6">
                                                              Item Code
                                                            </MDTypography>
                                                            <Select
                                                              className="select-css-for-itemcode"
                                                              maxMenuHeight={75}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  width:
                                                                    "305px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                !formik.values
                                                                  .itemsForLocation[
                                                                  index
                                                                ].skuStatus
                                                              }
                                                              options={
                                                                itemCodeForWarehouseOptions
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                setSelectedItemCode(
                                                                  selectedOption,
                                                                );
                                                                // getLocationsForQuarantine(selectedOption?.value, jwtToken);
                                                                formik.setFieldValue(
                                                                  `itemsForLocation.${index}.itemId`,
                                                                  selectedOption?.value,
                                                                );
                                                              }}
                                                              value={
                                                                itemsForLocation.itemId
                                                              }
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        {/* Location Field */}
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={6}
                                                          md={5.8}
                                                          lg={5.8}
                                                        >
                                                          <MDBox
                                                            ml={{
                                                              xs: 0,
                                                              // sm: 4.5,
                                                            }}
                                                            mb={2}
                                                          >
                                                            <MDTypography variant="h6">
                                                              Location
                                                            </MDTypography>
                                                            <Select
                                                              className="select-css-for-sku-item"
                                                              maxMenuHeight={75}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  width:
                                                                    "305px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                !formik.values
                                                                  .itemsForLocation[
                                                                  index
                                                                ].itemId
                                                              }
                                                              // isDisabled={!formik.values.itemsForLocation[index].itemId}
                                                              options={
                                                                locationOptions
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                setSelectedLocationId(
                                                                  selectedOption,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForLocation.${index}.location`,
                                                                  selectedOption?.value,
                                                                );
                                                              }}
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        {/* SKU Field */}
                                                        <Grid
                                                          item
                                                          xs={9}
                                                          sm={6}
                                                          md={4}
                                                          lg={4}
                                                        >
                                                          <MDBox
                                                            ml={{
                                                              xs: 0,
                                                              sm: -1,
                                                            }}
                                                          >
                                                            <MDTypography variant="h6">
                                                              SUID
                                                            </MDTypography>
                                                            <Select
                                                              // className="select-css-for-sku"
                                                              maxMenuHeight={70}
                                                              isClearable
                                                              styles={{
                                                                control: (
                                                                  provided,
                                                                ) => ({
                                                                  ...provided,
                                                                  borderRadius: 5,
                                                                  height:
                                                                    "36px",
                                                                  width:
                                                                    "305px",
                                                                  fontSize:
                                                                    "15px",
                                                                }),
                                                              }}
                                                              isDisabled={
                                                                !formik.values
                                                                  .itemsForLocation[
                                                                  index
                                                                ].location
                                                              }
                                                              options={
                                                                skuStatusOptions
                                                              }
                                                              onChange={(
                                                                selectedOption,
                                                              ) => {
                                                                const selectedSku =
                                                                  skuStatusOptions.find(
                                                                    (option) =>
                                                                      option.value ===
                                                                      selectedOption?.value,
                                                                  );
                                                                formik.setFieldValue(
                                                                  `itemsForLocation.${index}.sku`,
                                                                  selectedOption?.value,
                                                                );
                                                                formik.setFieldValue(
                                                                  `itemsForLocation.${index}.qty`,
                                                                  selectedSku?.qty ||
                                                                    0,
                                                                ); // Update qty
                                                              }}
                                                              value={skuStatusOptions.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  itemsForLocation.sku,
                                                              )}
                                                            />
                                                          </MDBox>
                                                        </Grid>

                                                        {/* Cancel/Add Buttons */}
                                                        <Grid
                                                          item
                                                          xs={3}
                                                          sm={6}
                                                          md={4}
                                                          lg={1}
                                                        >
                                                          <MDBox
                                                            display="flex"
                                                            alignItems="center"
                                                            mt={3}
                                                            ml={12}
                                                          >
                                                            {index > 0 && (
                                                              <CancelIcon
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                type="button"
                                                                className="secondary"
                                                                onClick={() =>
                                                                  remove(index)
                                                                }
                                                                color="error"
                                                              />
                                                            )}
                                                            {index ===
                                                              itemsForLocation.length -
                                                                1 && (
                                                              <Tooltip title="Add Items">
                                                                <AddCircleIcon
                                                                  fontSize="large"
                                                                  onClick={() =>
                                                                    push({
                                                                      itemId:
                                                                        "",
                                                                      location:
                                                                        "",
                                                                      skuStatus:
                                                                        "",
                                                                      sku: "",
                                                                    })
                                                                  }
                                                                  color="info"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                />
                                                              </Tooltip>
                                                            )}
                                                          </MDBox>
                                                        </Grid>
                                                      </Grid>
                                                    </div>
                                                  );
                                                },
                                              )}
                                            </div>
                                          );
                                        }}
                                      </FieldArray>
                                    </MDBox>
                                  )}

                                  <div
                                    style={{
                                      background: "white",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <MDButton
                                      style={{
                                        position: "sticky",
                                        bottom: "0",
                                      }}
                                      color="info"
                                      fullWidth
                                      type="submit"
                                      disabled={
                                        !formik.isValid ||
                                        !activityIdSelected ||
                                        buttonName === "Please wait..."
                                      }
                                    >
                                      {buttonName}
                                    </MDButton>
                                  </div>
                                  <MDBox>
                                    <Collapse in={isErrorCreatedQuarantine}>
                                      <Alert
                                        severity="error"
                                        action={
                                          <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                              setIsErrorCreatedQuarantine(
                                                false,
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="inherit" />
                                          </IconButton>
                                        }
                                      >
                                        {errorMsgForCreate}
                                      </Alert>
                                    </Collapse>
                                    <Collapse in={isSuccessCreatedQuarantine}>
                                      <Alert
                                        severity="success"
                                        action={
                                          <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                              setIsSuccessCreatedQuarantine(
                                                false,
                                              );
                                            }}
                                          >
                                            <CloseIcon fontSize="inherit" />
                                          </IconButton>
                                        }
                                      >
                                        Quarantine Created Successfully
                                      </Alert>
                                    </Collapse>
                                  </MDBox>
                                </div>
                              </Form>
                            );
                          }}
                        </Formik>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateUserModal}
              onClose={handleCloseAllocateUserModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForRelease}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Release
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseAllocateUserModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForRelease.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                        SUID:-{" "}
                        <span style={{ fontWeight: 400 }}>
                          {documentNumber}
                        </span>
                      </MDTypography>
                    </MDBox>

                    <MDBox>
                      <Collapse in={isErrorForAllocate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForAllocate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsg}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForAllocate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessForAllocate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Picklist released Successfully
                        </Alert>
                      </Collapse>
                    </MDBox>

                    <MDBox mt={1}>
                      <MDButton
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={
                          !formikForRelease.isValid ||
                          releaseName === "Please wait..."
                        }
                      >
                        {releaseName}
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>

      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    acceptedQuarantinesReducer: state.acceptedQuarantinesReducer,
    itemCodeByWarehouseReducer: state.itemCodeByWarehouseReducer,
    locationReducer: state.locationReducer,
    getSkuStatusByLocationAndItemCodeReducer:
      state.getSkuStatusByLocationAndItemCodeReducer,
    getSkuByItemCodeReducer: state.getSkuByItemCodeReducer,
    getSkuByDocumentNoReducer: state.getSkuByDocumentNoReducer,
    getCreatedActivityReducer: state.getCreatedActivityReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    createQuarantineForAcceptedListW2: (payload, jwtToken) =>
      dispatch(createQuarantineForAcceptedListW2(payload, jwtToken)),
    getAcceptedQuarantines: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getAcceptedQuarantines(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    getSkuStatusByLocationAndItemCode: (locationId, itemId, status, jwtToken) =>
      dispatch(
        getSkuStatusByLocationAndItemCode(locationId, itemId, status, jwtToken),
      ),
    releaseQuarantine: (payload, jwtToken) =>
      dispatch(releaseQuarantine(payload, jwtToken)),
    // createPickupListForQuarantineW2: (payload, jwtToken) =>
    //   dispatch(createPickupListForQuarantineW2(payload, jwtToken)),
    getItemCodeByWarehouse: (warehouseIdSelected, status, jwtToken) =>
      dispatch(getItemCodeByWarehouse(warehouseIdSelected, status, jwtToken)),
    getSkuByItemCode: (itemId, status, jwtToken) =>
      dispatch(getSkuByItemCode(itemId, status, jwtToken)),
    // getSkuStatusByLocationAndItemCode: (warehouseId, itemId, status, jwtToken) =>
    //   dispatch(
    //     getSkuStatusByLocationAndItemCode(warehouseId, itemId, status, jwtToken)
    //   ),
    getLocationsForQuarantine: (itemId, status, jwtToken) =>
      dispatch(getLocationsForQuarantine(itemId, status, jwtToken)),
    getDocumentType: (jwtToken) => dispatch(getDocumentType(jwtToken)),
    getCreatedActivity: (documentTypeSelected, jwtToken) =>
      dispatch(getCreatedActivity(documentTypeSelected, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getSkuByDocumentNo: (documentTrId, jwtToken) =>
      dispatch(getSkuByDocumentNo(documentTrId, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch,
)(AcceptedQuarantinesW2);
